/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseObject from "@shared/BaseObject";
import ScheduledEvent from "@shared/scheduler/ScheduledEvent";
import {Type} from "class-transformer";


export default class CalendarEventResponse extends BaseObject{

	@Type(() => ScheduledEvent)
	masterEventOld: ScheduledEvent = null
	@Type(() => ScheduledEvent)
	masterEventNew: ScheduledEvent = null


	// WARNING: server returns limited representation of the events below.
	// only startTime, duration, id and recurringMasterIds are guaranteed
	// Check server side implementation for details

	event: ScheduledEvent = null
	isRecurringEvent = false

	@Type(() => ScheduledEvent)
	recurringInstances: ScheduledEvent[] = []


	constructor(event: ScheduledEvent) {
		super();
		this.event = event;
	}
}
